import {
  AdditionalConfiguration,
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';

export class NotesConfiguration extends ReportSectionConfigurationBase {
  typeName = 'NotesConfiguration';
  nodataLocalizationKeyName = 'notes';
  readonly reportSection = ReportSection.Notes;
  readonly applicableReportTypes = [ReportType.Contact, ReportType.Institution];
  readonly reportViewModelSections = [ReportViewModelSection.InvestorProfile_Notes];
  readonly featureToggleKey = 'add-notes-section-in-investor-profile-report-ISD-17482';

  /**
   * This section is controlled by a feature toggle.
   * The feature toggle key is: 'add-notes-section-in-investor-profile-report-ISD-17482'
   * The toggle is handled at the selector level in both template-designer and template-library stores.
   */
  minSize = 1;
  maxSize = 4;
  defaultSize = 4;
  override additionalConfiguration: AdditionalConfiguration = {
    isTruncated: false,
    truncationLength: 7,
    toggleLabel: 'notesSectionTruncationToggle'
  };
  override readonly configurationControls = [
    {
      name: 'notesTruncation',
      displayName: 'Truncation',
      type: 'truncation',
      applicableDataSection: 'notes',
      defaultLength: 7
    }
  ];

  get availableDataSections(): ReportSectionDataSection[] {
    return [
      {
        name: 'notes',
        displayName: 'Notes',
        isSelected: true,
        canConfigure: true
      }
    ];
  }

  get name(): string {
    if (this.appliedReportType === ReportType.Contact) {
      return 'contactNotes';
    } else if (this.appliedReportType === ReportType.Institution) {
      return 'institutionNotes';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.Contact || this.appliedReportType === ReportType.Institution) {
      return 'Notes';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface NotesData {
  [ReportViewModelSection.InvestorProfile_Notes]: NotesContent | null;
}

export interface NotesContent {
  content: string;
  language: string;
}
